<template>
<div>
  <form class="weixin-form card-body p-0">
    <div class="text-center">
      <div class="qrCode">
        <div class="" id="weixinQrCode">
          <iframe :src="codeUrl" frameborder="0" scrolling="no" width="300px" height="400px">
          </iframe>
        </div>
        <div class="sflex-center hidden" style="width:160px;height:160px;background:#e9ecef;color:#6C757D;margin:0px auto">二维码生成中</div>
      </div>
      <div class="mt-2">
         <i class=" iconfont fab fa-weixin me-1 icon-weixin" style="color:#00B500"></i>微信扫码登录
      </div>
    </div>
  </form>
</div>
</template>

<script>
export default {
  name: "WxCodeLogin",
  data(){
    return {
      //codeUrl:'https://open.weixin.qq.com/connect/qrconnect?appid=wxd8936345ec1df5ac&scope=snsapi_login&redirect_uri=https://segmentfault.com/user/oauth/weixin&state=&login_type=jssdk&self_redirect=default&styletype=&sizetype=&bgcolor=&rst=&href=https://s.segmentfault.com/css/weixin.css',
      codeUrl:'https://open.weixin.qq.com/connect/qrconnect?appid=wx1cf46a153567809a&scope=snsapi_login&redirect_uri=http://pc_dev.yongxintao.com/wxlogin/oauth&state=&login_type=jssdk&self_redirect=default&styletype=&sizetype=&bgcolor=&rst=&href=https://server-order-api.yongxintao.com/static/css/weixin.css',
    }
  },
}
</script>

<style scoped>
.impowerBox .qrcode {
  width: 160px;
  height: 160px;
  margin-top: 0;
  border: 0;
}
.impowerBox .title {
  display: none;
}
.impowerBox .info {
  display: none;
}
.status_icon {
  display: none;
}
.impowerBox .status {
  text-align: center;
}


</style>
